module.exports = __webpack_public_path__ + "static/karta-kredytowa-c4a67807b2a0c5e17bf69f0c8c8dfd18.jpg";